import storage from '../common/utils/storage'

const currentUser = (user?: CurrentUser | null): CurrentUser | null => {
    if (user === null) {
        storage.removeItem('user')
        return null
    }

    if (typeof user !== 'undefined') {
        storage.setItem('user', user)
        return user
    }

    return storage.getItem('user')
}

export default currentUser

if (process.env.NODE_ENV === 'development') {
    Object.assign(window, { currentUser })
}

type Roles = {
    claim: string
    companyId: string
    chargePointUserId: string
}

export type CurrentUser = {
    id: string
    firstName: string
    lastName: string
    password: string
    passwordChange: { currentPassword: string; newPassword: string; passwordCompare: string } | null
    mobile: string
    email: string
    userType: string
    partnerId?: number
    personalAccept: string
    companyAccept: string | null
    lastLogin: string
    userName: string
    fullName: string
    hostName: string | null
    claims: Array<string>
    isPartner: boolean
    userStatus: 'Valid' | 'Locked'
    roles: Array<Roles>
    isSuperAdmin: boolean
    roleInCompany: string | null
    selectedCompanyId: string
    features: Array<string>
}
